import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
	state: {
		token: "",
		// 登录状态
		login: false,
		// 尾部隐藏
		is_login: true,
		is_title: false,
		is_title_show: true,
		is_looding: false,
		// 提示信息
		msg: "",
		// 监听提示变化
		msgup: 0,
		// 提示时长
		msgn: 2,
		listData: 0,
		theme_arr: [
			{
				nav_color: '#fff',
				nav_active_color: "#fff",
				nav_active_background: '#38A28A',
				nav_background: '#545c64',
				fold_color: "#38A28A",
				theme_color: '#38A28A',
				title_background: '#38A28A',
				title: '默认'
			},
			{
				nav_color: '#f7f',
				nav_active_color: "#ff8",
				nav_active_background: '#38A66A',
				nav_background: '#33Ae83',
				fold_color: "#f0e",
				theme_color: '#eeA28A',
				title_background: '#22Aee3',
				title: '主题2'
			},
			{
				nav_color: '#f2f',
				nav_active_color: "#f48",
				nav_active_background: '#eeA66A',
				nav_background: '#5422bb',
				fold_color: "#f0a",
				theme_color: '#edA28A',
				title_background: '#32dee3',
				title: '主题2'
			},
		],
		theme: {
			nav_color: '#fff',
			nav_active_color: "#fff",
			nav_active_background: '#38A28A',
			nav_background: '#545c64',
			fold_color: "#38A28A",
			theme_color: '#38A28A',
			title_background: '#38A28A',
			title: '默认'
		}
	},
	mutations: {
		// 储存token
		upToken(state, data) {
			state.token = data
		},
		// 登录状态
		upLogin(state, data) {
			state.login = data
		},
		uplistData(state, data) {
			state.listData++
		},
		// 提示消息
		upmsg(state, aa) {
			// 加入可自定义时间
			// this.$store.commit("upmsg", '11111');
			// this.$store.commit("upmsg", {t:'设为默认成功',n:20} );
			// console.log(typeof (aa))
			if (typeof (aa) == 'object') {
				state.msg = aa.t
				state.msgn = aa.n
			} else {
				state.msg = aa
			}
			state.msgup++
		},
		set_theme_arr(state, aa) {
			state.theme_arr = aa
		},
		set_theme(state, aa) {
			state.theme = aa
		}
	},
	getters: {

	}
})


// WEBPACK FOOTER //
// ./src/utils/store/store.js